import { Routes } from '@angular/router';

import { authGuard } from '../../core/guards/auth.guard';
import { NAV_ROUTES } from './nav/nav.routes';

export const MOBILE_MAIN_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./nav/nav.component').then(c => c.NavComponent),
    children: [...NAV_ROUTES],
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./profile/profile.component').then(c => c.ProfileComponent),
  },
  {
    path: 'parking-details/:id',
    loadComponent: () =>
      import('../../shared/parking-details-page/parking-details-page.component').then(
        c => c.ParkingDetailsPageComponent,
      ),
  },
  {
    path: 'sign-segment/:uuid',
    loadComponent: () =>
      import('../../shared/sign-segment-page/sign-segment-page.component').then(
        c => c.SignSegmentPageComponent,
      ),
  },
  {
    path: 'parking-order/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./parking-details/parking-order/parking-order.component').then(
        c => c.ParkingOrderComponent,
      ),
  },
  {
    path: 'search',
    loadComponent: () => import('./search/search.component').then(c => c.SearchComponent),
  },
];
